<template>
  <div
    class="relative flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-full"
  >
    <div
      class="rounded-extra-small flex h-5 w-5 items-center justify-center border-2 transition-all"
      :class="[
        isChecked && !disabled && 'bg-primary text-on-primary border-primary',
        !isChecked && !disabled && 'text-on-surface-variant border-on-surface-variant',
        isChecked && disabled && 'bg-on-surface text-surface border-on-surface opacity-38',
        !isChecked && disabled && 'text-on-surface-variant border-on-surface opacity-38',
      ]"
    >
      <BaseIcon
        size="18"
        class="invisible"
        :class="[isChecked && 'visible', !disabled && 'group-hover:visible']"
        >check</BaseIcon
      >
    </div>
    <BaseStateLayer v-if="showStateLayer" />
  </div>
</template>
<script setup lang="ts">
  import BaseIcon from '../icon/BaseIcon.vue'
  import BaseStateLayer from '../state-layer/BaseStateLayer.vue'
  interface Props {
    isChecked: boolean
    disabled?: boolean
    showStateLayer?: boolean
  }

  defineProps<Props>()
</script>
